import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/atoms/card";

interface FieldsStepProps {
  onNext: () => void;
}

export const FieldsStep = ({ onNext: _onNext }: FieldsStepProps) => {
  const { t } = useTranslation();

  const placeholder = "Fields step content";

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {t("library.onboardDocuments.steps.fields.cardTitle")}
        </CardTitle>
        <CardDescription>
          {t("library.onboardDocuments.steps.fields.cardDescription")}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground text-sm">{placeholder}</p>
      </CardContent>
    </Card>
  );
};
